import styled from 'styled-components';
import { GoToListPageButton } from '../../../../components/common/buttons/GoToListPageButton';
import { SwiperItemContainer } from '../../../../components/common/itemContainer/SwiperItemContainer';
import { IProduct } from '../../../../interfaces/Product.interfaces';
import { IProductForPreviewCard, ProductPreviewCard } from './ProductPreviewCard';

interface ProductPreviewCardSwiperProps {
  products: IProduct[];
  category: 'pluva' | 'partner';
  pageType: 'home' | 'pdp' | 'odp';
  currentProductForMarketAmpliEvent?: Partial<Pick<IProduct, 'category' | 'code'>>;
}

const SLIDE_WIDTH = 142;
const SLIDE_HEIGHT = 265;

export const ProductPreviewCardSwiper = ({
  products,
  category,
  pageType,
  currentProductForMarketAmpliEvent,
}: ProductPreviewCardSwiperProps) => {
  return (
    <Wrapper id={'home-product-swiper-container'}>
      <SwiperItemContainer
        slideItemWidth={SLIDE_WIDTH}
        slideItems={products.map((product) => (
          <ProductPreviewCard
            key={product.id}
            product={product as IProductForPreviewCard}
            currentProductForMarketAmpliEvent={currentProductForMarketAmpliEvent}
            listType={pageType}
          />
        ))}
        extraElement={{
          width: 150,
          element: <GoToListPageButton renderedIn={pageType} itemType={category} height={SLIDE_HEIGHT} />,
        }}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
`;
